<template>
  <div class="collections-button" @click="showModal">
    <BbIcon class="collections-icon" name="collection" type="filled" />
    <div v-if="collectionsCount" class="collections-count">
      {{ collectionsCount }}
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import useModals from '~/composables/useModals';
import useCollections from '~/composables/useCollections';
import { CURRENT_DIALOG } from '~/constants/conversationModels';

export default {
  name: 'CollectionsMenu',
  components: {},

  setup() {
    const { setCurrentDocumentsDialog } = useModals();
    const { currentCollections } = useCollections();
    const collectionsCount = computed(() => currentCollections.value.length);
    const showModal = () => {
      setCurrentDocumentsDialog(CURRENT_DIALOG.collections_panel);
    };

    return {
      collectionsCount,
      showModal,
    };
  },
};
</script>

<style scoped lang="scss">
.collections-button {
  position: relative;
  padding: $bb-spacing-2;
  border-radius: 8px;
  cursor: pointer;
  line-height: 1;

  &:hover,
  &.active {
    background: $bb-interface-8;
  }

  .collections-icon {
    color: $bb-neutral-1;
  }

  .collections-count {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 3px;
    left: 21px;
    width: 17px;
    height: 17px;
    background: $bb-interface-5;
    border: 1px solid $bb-neutral-0;
    border-radius: 100px;
  }
}
</style>
